export function debounce(fn: Function, delay: number, immediate?: boolean) {
	let timer: any = null;
	let lastParams: any[] = [];
	const debounced = (...params: any[]) => {
		lastParams = params;
		if (timer) {
			clearTimeout(timer);
		}
		if (immediate && !timer) {
			fn.call(null, ...params);
		} else {
			timer = setTimeout(() => {
				timer = null;
				fn.call(null, ...params);
			}, delay);
		}
	};
	debounced.cancel = () => {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}
	};
	/** Run a pending invocation immediately (with the latest arguments) instead of waiting out the delay. */
	debounced.flush = () => {
		if (timer) {
			clearTimeout(timer);
			timer = null;
			fn.call(null, ...lastParams);
		}
	};
	return debounced;
}

/** A utility function to delay foor a given time in milliseconds, returning a promise */
export const delay = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms));
